import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import * as autoThunks from 'features/auto-thunks'
import CuratedSeriesList from './curated-series-list-model'
import {
  CreateCuratedSeriesListAsync,
  DeleteCuratedSeriesListAsync,
  LoadCuratedSeriesListsAsync,
} from './curatedSeriesList-thunk'
const initialState: curatedSeriesListSliceState = {
  curatedSeriesList: [],
  selected_curatedSeriesList: '',
  is_loading_curatedSeriesList: false,
  is_creating_curatedSeriesList: false,
  is_deleting_curatedSeriesList: false,
}
export interface curatedSeriesListSliceState {
  curatedSeriesList: CuratedSeriesList[]
  selected_curatedSeriesList?: string
  is_loading_curatedSeriesList: boolean
  is_creating_curatedSeriesList: boolean
  is_deleting_curatedSeriesList: boolean
}
export const curatedSeriesListSlice = createSlice({
  name: 'curatedSeriesList',
  initialState,
  reducers: {
    setSelectedcuratedSeriesList: (state, action) => {
      state.selected_curatedSeriesList = action.payload
    },
    clearStatecuratedSeriesList: (state) => {
      state.curatedSeriesList = []
      state.is_loading_curatedSeriesList = false
      state.is_creating_curatedSeriesList = false
      state.is_deleting_curatedSeriesList = false
    },
    mergecuratedSeriesList: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_curatedSeriesList = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.curatedSeriesList = merge(
            state.curatedSeriesList,
            payload,
          ) as any
        }
      }
    },

    add_curatedSeriesList: (state, action) => {
      if (action.payload) {
        state.curatedSeriesList = [...state.curatedSeriesList, action.payload]
      }
    },
    set_curatedSeriesList: (state, action) => {
      let { key, value, id } = action.payload
      state.curatedSeriesList = state.curatedSeriesList.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadCuratedSeriesListsAsync.pending, (state) => {
      state.is_loading_curatedSeriesList = true
    })
    builder.addCase(LoadCuratedSeriesListsAsync.fulfilled, (state, action) => {
      state.is_loading_curatedSeriesList = false
      if (action.payload) {
        state.curatedSeriesList = action.payload
      }
    })
    builder.addCase(LoadCuratedSeriesListsAsync.rejected, (state) => {
      state.is_loading_curatedSeriesList = false
    })
    builder.addCase(CreateCuratedSeriesListAsync.pending, (state) => {
      state.is_creating_curatedSeriesList = true
    })
    builder.addCase(CreateCuratedSeriesListAsync.fulfilled, (state) => {
      state.is_creating_curatedSeriesList = false
    })
    builder.addCase(CreateCuratedSeriesListAsync.rejected, (state) => {
      state.is_creating_curatedSeriesList = false
    })
    builder.addCase(DeleteCuratedSeriesListAsync.pending, (state) => {
      state.is_deleting_curatedSeriesList = true
    })
    builder.addCase(DeleteCuratedSeriesListAsync.fulfilled, (state, action) => {
      state.is_deleting_curatedSeriesList = false
      if (state.curatedSeriesList) {
        state.curatedSeriesList = state.curatedSeriesList.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteCuratedSeriesListAsync.rejected, (state) => {
      state.is_deleting_curatedSeriesList = false
    })

    builder.addCase(autoThunks.load_curated_series_list.pending, (state) => {
      state.is_loading_curatedSeriesList = true
    })
    builder.addCase(
      autoThunks.load_curated_series_list.fulfilled,
      (state, action) => {
        state.is_loading_curatedSeriesList = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.load_curated_series_list.rejected, (state) => {
      state.is_loading_curatedSeriesList = false
    })

    builder.addCase(autoThunks.get_curated_series_list.pending, (state) => {
      state.is_loading_curatedSeriesList = true
    })
    builder.addCase(
      autoThunks.get_curated_series_list.fulfilled,
      (state, action) => {
        state.is_loading_curatedSeriesList = false
        handleResult(action, state)
      },
    )
    builder.addCase(autoThunks.get_curated_series_list.rejected, (state) => {
      state.is_loading_curatedSeriesList = false
    })

    builder.addCase(autoThunks.storeCuratedSeriesListAsync.pending, (state) => {
      state.is_loading_curatedSeriesList = true
    })
    builder.addCase(
      autoThunks.storeCuratedSeriesListAsync.fulfilled,
      (state, action) => {
        state.is_loading_curatedSeriesList = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.storeCuratedSeriesListAsync.rejected,
      (state) => {
        state.is_loading_curatedSeriesList = false
      },
    )

    builder.addCase(
      autoThunks.deleteCuratedSeriesListAsync.pending,
      (state) => {
        state.is_loading_curatedSeriesList = true
      },
    )
    builder.addCase(
      autoThunks.deleteCuratedSeriesListAsync.fulfilled,
      (state, action) => {
        state.is_loading_curatedSeriesList = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.deleteCuratedSeriesListAsync.rejected,
      (state) => {
        state.is_loading_curatedSeriesList = false
      },
    )

    builder.addCase(
      autoThunks.load_curated_series_list_for_system_schedules.pending,
      (state) => {
        state.is_loading_curatedSeriesList = true
      },
    )
    builder.addCase(
      autoThunks.load_curated_series_list_for_system_schedules.fulfilled,
      (state, action) => {
        state.is_loading_curatedSeriesList = false
        handleResult(action, state)
      },
    )
    builder.addCase(
      autoThunks.load_curated_series_list_for_system_schedules.rejected,
      (state) => {
        state.is_loading_curatedSeriesList = false
      },
    )
  },
})

function handleResult(action: any, state: curatedSeriesListSliceState) {
  if (action.payload) {
    let payload: any = action.payload
    if (payload?.data) {
      if (!Array.isArray(payload.data)) {
        state.selected_curatedSeriesList = payload?.data?.id
        payload = [payload.data]
      } else {
        payload = payload.data
      }
      state.curatedSeriesList = merge(state.curatedSeriesList, payload) as any
    }
  }
}

export const {
  clearStatecuratedSeriesList,
  setSelectedcuratedSeriesList,
  set_curatedSeriesList,
  mergecuratedSeriesList,
  add_curatedSeriesList,
} = curatedSeriesListSlice.actions

export const get_curatedSeriesList =
  (id?: string) =>
  (state: {
    curatedSeriesList: {
      curatedSeriesList: CuratedSeriesList[]
    }
  }): CuratedSeriesList | null => {
    let temp = state?.curatedSeriesList?.curatedSeriesList?.find(
      (v) => v.id === id,
    )
    if (temp) {
      return temp
    }
    return state?.curatedSeriesList?.curatedSeriesList[0] || null
  }
export const get_selected_curatedSeriesList = (state: {
  curatedSeriesList: curatedSeriesListSliceState
}): CuratedSeriesList | null => {
  let id = state?.curatedSeriesList?.selected_curatedSeriesList
  let temp = state?.curatedSeriesList?.curatedSeriesList?.find(
    (v) => v.id === id,
  )
  if (temp) {
    return temp
  }
  return null
}
export const get_all_curatedSeriesList = (state: {
  curatedSeriesList: {
    curatedSeriesList: CuratedSeriesList[]
  }
}): CuratedSeriesList[] => {
  let temp = state?.curatedSeriesList?.curatedSeriesList
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_curatedSeriesList_busy = (state: {
  curatedSeriesList: curatedSeriesListSliceState
}) => {
  return (
    state?.curatedSeriesList.is_deleting_curatedSeriesList ||
    state?.curatedSeriesList.is_loading_curatedSeriesList ||
    state?.curatedSeriesList.is_creating_curatedSeriesList
  )
}
export const is_deleting_curatedSeriesList_busy = (state: {
  curatedSeriesList: curatedSeriesListSliceState
}) => {
  return state?.curatedSeriesList.is_deleting_curatedSeriesList
}
export const is_loading_curatedSeriesList_busy = (state: {
  curatedSeriesList: curatedSeriesListSliceState
}) => {
  return state?.curatedSeriesList.is_loading_curatedSeriesList
}
export const is_creating_curatedSeriesList_busy = (state: {
  curatedSeriesList: curatedSeriesListSliceState
}) => {
  return state?.curatedSeriesList.is_creating_curatedSeriesList
}

export default curatedSeriesListSlice.reducer
